import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useLang } from "../contexts/LanguageContext";
import useDocumentSEO from "../lib/useDocumentSEO";
import Nav from "../components/site/Nav";
import Hero from "../components/site/Hero";
import Statement from "../components/site/Statement";
import ProjectsGrid from "../components/site/ProjectsGrid";
import Services from "../components/site/Services";
import WhoWeAre from "../components/site/WhoWeAre";
import CTABand from "../components/site/CTABand";
import Footer from "../components/site/Footer";
import BackToTop from "../components/site/BackToTop";

export default function HomePage() {
  const [content, setContent] = useState(null);
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const { lang, t } = useLang();

  useEffect(() => {
    let cancelled = false;
    Promise.all([api.get("/site-content"), api.get("/projects", { params: { status: "published" } })])
      .then(([cRes, pRes]) => {
        if (cancelled) return;
        setContent(cRes.data);
        setProjects(pRes.data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
    return () => {
      cancelled = true;
    };
  }, []);

  useDocumentSEO({
    title: content
      ? `${t(content.logo?.wordmark) || "Cipta Andalan"} — ${t(content.hero?.headline)}`
      : "Cipta Andalan",
    description: t(content?.hero?.supporting) ||
      "PT Cipta Andalan Persada — design & build consultancy. Architecture, construction, and interiors.",
    lang,
  });

  if (loading || !content) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white text-[#5d5f64]">
        <div className="text-sm tracking-wide">Loading…</div>
      </div>
    );
  }

  return (
    <div className="bg-white">
      <Nav content={content} />
      <main>
        <Hero content={content} />
        <Statement content={content} />
        <ProjectsGrid content={content} projects={projects} />
        <Services content={content} />
        <WhoWeAre content={content} />
        <CTABand content={content} />
      </main>
      <Footer content={content} />
      <BackToTop />
    </div>
  );
}
